import { render } from "./JobsGame.vue?vue&type=template&id=59754d02&scoped=true"
import script from "./JobsGame.vue?vue&type=script&lang=js"
export * from "./JobsGame.vue?vue&type=script&lang=js"

import "./JobsGame.vue?vue&type=style&index=0&id=59754d02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59754d02"]])

export default __exports__